export const config = {
	supportEmail: 'b.bosini@italianfood.net'
}
